import BaseModelAPI from '../BaseModelAPI';

export default class ProductionQualityInspectionDimensionList extends BaseModelAPI {

	static entity = 'productionqualityinspectiondimensionlist'
	static entityName = 'productionqualityinspectiondimension';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
